import { Component, ChangeDetectionStrategy, Input, OnChanges, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Faktura, FakturaView, InvoiceFilterOptions } from '@store/models';
import { InvoiceContainerComponent } from '../invoice/invoice.container';

@Component({
    selector: 'app-invoices-list',
    templateUrl: './invoices-list.component.html',
    styleUrls: ['./invoices-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class InvoicesListComponent implements OnChanges {

    @Input() invoices: FakturaView[];
    @Input() filterOptions: InvoiceFilterOptions;
    @Input() showClient = true;
    @Input() markable = false;
    @Output() markedInvoices = new EventEmitter<number[]>();
    @Output() reloadInvoices = new EventEmitter();
    filteredInvoices: FakturaView[];
    _markedInvoices: number[] = [];
    allChecked = false;

    constructor(
        private cdref: ChangeDetectorRef,
        private ngbModal: NgbModal
    ) { }

    ngOnChanges() {
        this.setFilteredInvoices();
        this.unmarkInvalidMarked();
    }

    setFilteredInvoices() {
        this.filteredInvoices = this.invoices
            ?.filter(invoice => this.hasFilterTerms(invoice))
            .sort((a, b) => b.fnr - a.fnr);
    }

    unmarkInvalidMarked() {
        if (!this.filteredInvoices) { return; }
        const ikkeGodkendteFilteredInvoices = this.filteredInvoices.filter(fi => fi.godkendt === null);
        const ikkeGodkendteFilteredInvoicesFnrs = ikkeGodkendteFilteredInvoices.map(fi => fi.fnr);
        this._markedInvoices = this._markedInvoices.filter(
            mis => ikkeGodkendteFilteredInvoicesFnrs.includes(mis)
        );
        this.setAllMarked();
    }

    hasFilterTerms(invoice: FakturaView) {
        if (!this.filterOptions) { return true; }
        if (this.filterOptions.la && this.filterOptions.la.cardId !== invoice.ledelsesansvarlig) {
            return false;
        }
        if (this.filterOptions.ka && this.filterOptions.ka.cardId !== invoice.kundeansvarlig) {
            return false;
        }
        if (this.filterOptions.acontoOnly && !invoice.aconto) {
            return false;
        }
        if (this.filterOptions.godkendteOnly === true && !invoice.godkendt) {
            return false;
        }
        if (this.filterOptions.godkendteOnly === false && invoice.godkendt) {
            return false;
        }
        const searchTerm = this.filterOptions.searchFor?.toLocaleLowerCase() || '';
        const glkundenr = invoice.glkundenr?.toString();
        const kundenavn = invoice.kundenavn?.toLocaleLowerCase();
        if (glkundenr?.includes(searchTerm) || kundenavn?.includes(searchTerm)) {
            return true;
        }
        return false;
    }

    onInvoice(fnr: number, kid: number) {
        const invoiceModal = this.ngbModal.open(InvoiceContainerComponent, {size: 'lg', backdrop: 'static', scrollable: true});
        invoiceModal.componentInstance.fnr = fnr;
        invoiceModal.componentInstance.kid = kid;
        invoiceModal.result
            .then((faktura: Faktura) => {
                if (!faktura) {
                    this.reloadInvoices.emit();
                    return;
                }
                const updatedFaktura = this.invoices.find(f => f.fnr === faktura.fnr);
                Object.keys(updatedFaktura).forEach(key => updatedFaktura[key] = faktura[key] || updatedFaktura[key]);
                this.invoices = [...this.invoices.filter(f => f.fnr !== faktura.fnr), updatedFaktura];
                this.cdref.detectChanges();
            })
            .catch(err => console.log('faktura modal catch', err));
    }

    onInvoiceMark(marked: boolean, fnr: number) {
        marked
            ? this._markedInvoices = [...this._markedInvoices, fnr]
            : this._markedInvoices = this._markedInvoices.filter(i => i !== fnr);
        this.setAllMarked();
        this.markedInvoices.emit(this._markedInvoices);
    }

    onAllInvoiceMark(marked: boolean) {
        this.allChecked = marked;
        marked
            ? this._markedInvoices = this.filteredInvoices.filter(i => i.godkendt === null).map(i => i.fnr)
            : this._markedInvoices = [];
        this.markedInvoices.emit(this._markedInvoices);
    }

    setAllMarked() {
        this._markedInvoices.length === this.filteredInvoices.filter(i => i.godkendt === null).length
            ? this.allChecked = true
            : this.allChecked = false;
    }

    trackByFnr(_: number, invoice: FakturaView) {
        return invoice.fnr;
    }
}
